import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const CampaignHub = (): unknown => {
    return import(/* webpackPrefetch: true */ './campaign-hub-page.vue');
};

export const campaignHubRoute: RouteRecordRaw = {
    ...ROUTE_DATA.CAMPAIGN_HUB_PAGE,
    components: {
        main: CampaignHub
    }
};
